import * as React from "react";
import { TooltipApi } from "sb-resp-ui";
export class EventCardIcon extends React.PureComponent {
    constructor(props) {
        super(props);
        this.tooltip = TooltipApi.getInstance().setMessage(this.props.tooltip);
    }
    render() {
        const addClassName = this.props.className ? this.props.className : "";
        return (React.createElement("div", Object.assign({ className: `rj-ev-list__ev-card-icon ${addClassName}`, onClick: this.props.onClick }, this.tooltip, { "data-uat": "div-ev-list-ev-card-icon" }), this.props.children));
    }
}
//# sourceMappingURL=EventCardIcon.js.map